import React from 'react';
import {labelDashboardSnackbar} from "./LabelDashboardSnackbar";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export default function DashboardSnackbar(props) {

    const langPref = props.beagleLanguagePreference;
    const msg = labelDashboardSnackbar.labelNetworkUnavailable[langPref];

    const [hasSnackbarBeenDisplayed, setHasSnackbarBeenDisplayed] = React.useState(false);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const handleCloseSnackbar = (event, reason) => {
        setOpenSnackbar(false);
    };

    //Has the snackbar already been displayed?
    if (hasSnackbarBeenDisplayed === false) {
        //Open the snackbar if the network is unavailable.
        if (props.awsNetworkCounter === -1) {
            setOpenSnackbar(true);
            setHasSnackbarBeenDisplayed(true);
        }
    }


    return (
        <Snackbar open={openSnackbar} autoHideDuration={9000} onClose={handleCloseSnackbar}>
            <Alert onClose={handleCloseSnackbar} severity="error">
                {msg}
            </Alert>
        </Snackbar>
    )

}
